export default "__VITE_ASSET__B$e0Fsox__"